import React, { useCallback, useContext } from "react";
import { Box, Grid } from "@material-ui/core";
import { Search } from "./search-filters";
import { UPDATE_FILTERS_DATA } from "../state";
import { TableContext } from "../table";

export const AccessAdminModalToolbar: React.FC = () => {
  const { dispatch } = useContext(TableContext);
  const onSearchUpdate = useCallback(
    (term: string) => {
      dispatch({
        type: UPDATE_FILTERS_DATA,
        filtersData: { searchTerm: term },
      });
    },
    [dispatch]
  );

  return (
    <Box mt={2} mb={2}>
      <Grid container direction="row" spacing={2}>
        <Grid item xs={3}>
          <Search
            onSearchUpdate={onSearchUpdate}
            placeholder={"Search by Email"}
          ></Search>
        </Grid>
      </Grid>
    </Box>
  );
};
